import Vue from "vue";
import VueRouter from "vue-router";

import moduleRouters from "@/module/router";
import authPlugin from "@/plugins/auth";
import store from '@/store'

import { crmUrl } from "@/config/customization";
import { Form } from "element-ui";
import { getQueryObject } from "@/utils"
// import { getTuiTuiH5AppParams } from "@/config";

const Login = (resolve) => require(["@/components/login/Login.vue"], resolve);
const Login1 = (resolve) => require(["@/components/login/Login1.vue"], resolve);
const ForgetPassword = (resolve) =>
  require(["@/components/login/ForgetPassword.vue"], resolve);
const Main = (resolve) => require(["@/components/main/Main.vue"], resolve);
const Main1 = (resolve) => require(["@/components/main/Main1.vue"], resolve);
const Home = (resolve) => require(["@/module/home/Home.vue"], resolve);
const Home1 = (resolve) => require(["@/module/home/Home1.vue"], resolve);
const Unauthorized = (resolve) => require(["@/components/401.vue"], resolve);
const NotFound = (resolve) => require(["@/components/404.vue"], resolve);
const InternalServerError = (resolve) =>
  require(["@/components/500.vue"], resolve);
const Auth = (resolve) => require(["@/components/auth.vue"], resolve); //<!--停止使用-->
const Authorize = (resolve) => require(["@/components/authorize.vue"], resolve);
const IFrameContainer = (resolve) =>
  require(["@/components/external/IFrameContainer.vue"], resolve);

const Quotation=  (resolve) =>
  require(["@/module/quotation/index.vue"], resolve);

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "/main",
      redirect: {
        name: "login",
      },
      component: Main,
      children: [
        {
          path: "external/:url",
          name: "external",
          component: IFrameContainer,
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      meta: {
        keepAlive: true,
        allowAnonymous: true,
      },
      component: Login,
    },
    {
      path: "/login1",
      name: "login1",
      meta: {
        keepAlive: true,
        allowAnonymous: true,
      },
      component: Login1,
    },
    {
      path: "/forget",
      name: "forget",
      meta: {
        keepAlive: true,
        allowAnonymous: true,
      },
      component: ForgetPassword,
    },
    {
      path: "/401",
      name: "401",
      component: Unauthorized,
      meta: {
        allowAnonymous: true,
      },
    },
    {
      path: "/404",
      name: "404",
      component: NotFound,
      meta: {
        allowAnonymous: true,
      },
    },
    {
      path: "/500",
      name: "500",
      component: InternalServerError,
      meta: {
        allowAnonymous: true,
      },
    },
    {
      path: "/auth/:userId/:targetUrl",
      name: "auth",
      component: Auth,
      meta: {
        allowAnonymous: true,
      },
    },
    {
      path: "/authorize",
      name: "authorize",
      component: Authorize,
      meta: {
        allowAnonymous: true,
      },
    },
    {
      path: "/quotation",
      name: "quotation",
      component: Quotation,
      meta: {
        allowAnonymous: true,
      },
    },

    ...generateRoutesFromModules(),
    {
      path: "*",
      redirect: "/404",
    },
  ],
});

//注册一个全局的 before 钩子，对于需要登录才能访问的模块进行控制进行控制

router.beforeEach(async (to, from, next) => {
  console.log('beforeEach-to',to);
  console.log('beforeEach-from',from);
  console.log('window.location.href',window.location.href)
  // if (to.path === '/xxx' && from.path !== '/xxx') {
  //   next('/other-path');
  // } else {
  //   next();
  // }

  const auth = router.app.$options.store.state.auth;
  if (window.location.href.includes("appid")) {//推推页面才有appid
    router.app.$options.store.commit("UPDATE_HIDDEN_HEADER", true);//是推推页面切换导航
    console.log('loginByTuiTui')
    /*
      如果未登陆，刷新页面，获取5个单点参数去sign_on，再获取用户信息
      如果已登陆，获取用户信息
    */
    if (!auth.isLoggedIn) {
      // 如果在推推环境下，未登陆，则调用登陆和获取用户信息
      try {
        await authPlugin.tuitui_login({
          ...getQueryObject(location.href),
          channel: "crm",
        });  
      } catch (error) {
        console.log('tuitui_login-error',error)
        return false
      }
    }else { // 获取用户信息
      const user = router.app.$options.store.state.user;
      if (!user.UserName) {
        try {
          await authPlugin.fetchUserInfo();
        } catch (error) {
          console.log('已登陆-获取用户信息-error',error)
          return false
          // rt.showErrorToast(error);
        } 
      }
    }
  }

  if (window.location.href.includes("route=")) {
    // 判断消息有route参数，直接跳转到详情
    const { route } = getQueryObject(location.href)
    console.log('enter-route=',route,to.path)
    if (to.path !== route) {
      // 创建URL对象
      const url = new URL(window.location.href);

      // 删除route参数
      url.searchParams.delete('route');

      // 去掉hash部分
      url.hash = '';

      // 获取去掉route参数和hash后的URL
      const modifiedUrl = url.toString();
      console.log('modifiedUrl',modifiedUrl)
      // 使用history.pushState改变浏览器地址栏中的URL，但不跳转
      window.history.pushState({}, '', modifiedUrl);
      next(route)
    }
  }

  console.log('to.path',to.path)
  console.log('window.location.href',window.location.href)

  if (from.name == "OrderConfirm" && to.name != "OrderComplete") {
    console.log('OrderConfirm');
    if (from.query.source == "1") {
      let url = "api/Order/OrderReturn?id=" + from.params.id;
      rt.post(url)
        .then((res) => {
          let url = "api/Order/DeleteOrder?id=" + from.params.id;
          return rt.post(url);
        })
        .then((res) => {
          if (to.name == "ShoppingMallChooseProduct") {
            location.reload();
          }
        })
        .catch((error) => {
          rt.showErrorToast(error);
        });
    } else if (from.query.source == "2") {
      let url = "api/Order/DeleteOrder?id=" + from.params.id;
      rt.post(url).then((res) => {
        localStorage.confirmBack = true;
        if (to.name == "ShoppingMallChooseProduct") {
          location.reload();
        }
      });
    }

  }
  const isStore = router.app.$options.store.state.isStore;
  const hiddenHeader = router.app.$options.store.state.hiddenHeader;

  //false:非商场，1true：商场
  if (to.name == "home1" || to.name == "login1") {
    if (isStore == true) {
      next({
        name: "home",
      });
    }
  }

  if (to.name == "home" || to.name == "login") {
    if (isStore == false) {
      to.meta.allowAnonymous = false;
      console.log('进来了吗？')
      if (!auth.isLoggedIn) {
        //如果没有登录，则跳到登录页面
        next({
          name: "login1",
        });
      } else {
        //如果已经登录，则判断是否有页面访问权限
        next({
          name: "home1",
        });
      }
    }
  }
  if (to.meta && to.meta.allowAnonymous) {
    if (to.name === "auth" || to.name === "authorize") {
      authPlugin.clearAllData();
    }
    next();
    return;
  }

  //针对嵌入到CRM的页面的处理
  if (to.name && to.name.contains("crm__")) {
    guardCrmRoute(to, from, next);
    return;
  }

  if (to.name && to.name != "login1" && !isStore && !auth.isLoggedIn && !hiddenHeader) {
    console.log('进来了吗2？')
    next({
      name: "login1",
    });
  }
  // if (isStore == false) {
  //   to.matched[0].components.default = Main1
  // }

  //针对PORTAL页面的处理
  if (isStore === true) {
    guardRoute(to, from, next);
  } else {
    guardStoreRoute(to, from, next); // 实际只走这个
  }
});

async function guardStoreRoute(to, from, next) {
  //如果是非Portal用户登录产生的auth,直接退出重新登录
  const user = router.app.$options.store.state.user;
  if (user != null && user.loginType != null && user.loginType == "sso_mscrm") {
    authPlugin.logout();
    return;
  }
 
  if (hasPermission(to)) {
    console.log('hasPermission-next')
    next();
  } else {
    next({
      name: "401"
    });
  }
    
}

function generateRoutesFromModules() {
  return moduleRouters;
}

function guardCrmRoute(to, from, next) {
  if (from.fullPath == "/") {
    authPlugin.clearAllData();
  }
  const auth = router.app.$options.store.state.auth;
  if (!auth.isLoggedIn) {
    var redirectUrl =
      location.origin +
      location.pathname +
      "#/authorize?redirect_url=" +
      encodeURIComponent(to.path);
    var data = encodeURIComponent(
      "redirect_url=" + encodeURIComponent(redirectUrl)
    );
    //var data = encodeURIComponent("redirect_url=" + encodeURIComponent(to.path));

    window.location.href =
      crmUrl + "/WebResources/new_/connect/authorize.html?Data=" + data;
  } else {
    next();
  }
}

function guardRoute(to, from, next) {
  console.log("nostore,不会走这里");

  //如果是非Portal用户登录产生的auth,直接退出重新登录
  const user = router.app.$options.store.state.user;
  if (user != null && user.loginType != null && user.loginType == "sso_mscrm") {
    authPlugin.logout();
    return;
  }

  const auth = router.app.$options.store.state.auth;
  console.log(auth);
  //判断有没有登录
  if (!auth.isLoggedIn) {
    //如果没有登录，则跳到登录页面
    if (to.name === "home") {
      next({
        name: "login",
      });
    } else {
      next({
        name: "login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    //如果已经登录，则判断是否有页面访问权限
    if (hasPermission(to)) {
      next();
    } else {
      next({
        name: "401",
      });
    }
  }
}

function hasPermission(router) {
  //页面需要的权限列表
  var requiredPermissions = router.meta && router.meta.requiredPermissions;
  if (!requiredPermissions || requiredPermissions.length == 0) {
    return true;
  }

  //当前用户授权的权限列表
  var userPermissions = window.GLOBAL_USER_ACTIONS || [];
  if (userPermissions.length == 0) {
    return false;
  }

  for (var i = 0; i < requiredPermissions.length; i++) {
    var isMatched = false;
    for (var j = 0; j < userPermissions.length; j++) {
      if (requiredPermissions[i] == userPermissions[j]) {
        isMatched = true;
      }
    }

    //页面需要的权限，只要有一个不满足，就返回false
    if (!isMatched) {
      return false;
    }
  }

  return true;
}


// try {
//   getTuiTuiH5AppParams()
//   .then(res => {
//     console.log('h5AppParams',res,window.location.href)
//     if (window.location.href.includes("route=")) {
//       // 判断消息有route参数，直接跳转到详情
//       // const { route } = getQueryObject(location.href)
//       // console.log('enter-route=',route,to.path)
//       // if (to.path !== route) {
//       //   // 创建URL对象
//       //   const url = new URL(window.location.href);
  
//       //   // 删除route参数
//       //   url.searchParams.delete('route');
  
//       //   // 去掉hash部分
//       //   url.hash = '';
  
//       //   // 获取去掉route参数和hash后的URL
//       //   const modifiedUrl = url.toString();
//       //   console.log('modifiedUrl',modifiedUrl)
//       //   // 使用history.pushState改变浏览器地址栏中的URL，但不跳转
//       //   window.history.pushState({}, '', modifiedUrl);
//       //   next(route)
//       // }
//     }
//   })
  
// } catch (err) {
//   console.log('h5AppParams-error',err)
// }

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js